module.exports = __webpack_public_path__ + "static/img/c0d98eedc68db4fe7f5b70afee66ba7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/service_jgbackground.jpg
// module id = NVW5
// module chunks = 1